export default __webpack_public_path__ + "static/third-50d9f6ceb82e662887d4519c6172c6d5.svg";